import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';
import { BookValuesContext, NetworkStatusValuesContext } from 'contexts';
import { ChapterList } from 'components';
import ToCListItem from './ToCListItem';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      ...theme.typography.body2,
    },
  };
});

const TableOfContents = ({ className, onClose, ...props }) => {
  const classes = useStyles();

  const { book } = useContext(BookValuesContext);
  const { isOffline } = useContext(NetworkStatusValuesContext);

  const topLevelMarkers = book.topLevelMarkers;

  return (
    <div className={clsx(classes.root, className)} {...props}>
      <ChapterList>
        {topLevelMarkers.map((marker) => (
          <React.Fragment key={`ToC-${marker.index}`}>
            <ToCListItem
              onNavigateClick={onClose}
              isOffline={isOffline}
              marker={marker}
            />
          </React.Fragment>
        ))}
      </ChapterList>
    </div>
  );
};

TableOfContents.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default memo(TableOfContents);
